import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Box } from "theme-ui";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3 {...{
      "id": "start-with-an-interactive-cheatsheet-"
    }}>{`Start with an interactive cheatsheet 📖`}</h3>
    <p>{`Then get thoughtful
letters 💌 on `}<strong parentName="p">{`mindsets, tactics, and technical skills`}</strong>{` for your
career.`}</p>
 <Box sx={{
      textAlign: "left"
    }} mdxType="Box">
      <p>{`"Man, love your simple writing! Yours is the only email I open
from marketers and only blog that I give a fuck to read & scroll
till the end. And wow always take away lessons with me.
Inspiring! And very relatable. 👌"`}</p>
      <p>{`~ `}<a parentName="p" {...{
          "href": "https://twitter.com/ashfame/status/1286756578226405376"
        }}>{`Ashish Kumar`}</a></p>
    </Box>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      